// extracted by mini-css-extract-plugin
module.exports = {"mark":"PlanSectionMark_mark__12rXd","content":"PlanSectionMark_content__11n4q","title":"PlanSectionMark_title__1IQ58"};